import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { Alert, message } from 'antd'
import moment from 'moment'

import { getUri } from '../../../services/springCenfApi'
import { storeDownloadToken } from '../../DownloadTokens/services'
import { handleError, serialize } from '../../../helpers'

export default function DownloadReportModal({ 
	visible, onClose, data
}) {
	const user_id = useSelector(state => state.auth.user.id)
	const [loading, setLoading] = useState(false)
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: {
			from: moment().subtract('1', 'month').format('YYYY-MM-DD'),
			to: moment().format('YYYY-MM-DD'),
		}
	})

	const onSubmit = values => {
		setLoading(true)
		let token = new Date().getTime()
		storeDownloadToken({ type: `Descarga de ${data.title}`, token, user_id })
			.then(() => {
				message.info('Generando reporte en nueva pestaña')
				window.open(`${getUri()}/reports/export/${data.slug}/${token}?${serialize(values)}`)
				onClose()
			})
			.catch(error => handleError(error))
			.finally(() => setLoading(false))
	}

	return (
		<>
			<Modal isOpen={visible}>
				<ModalHeader toggle={onClose}>Descargar Reporte</ModalHeader>
				<ModalBody>
					<h6 className='mb-10 pr-10'>Reporte: {data.title}</h6>
					<Alert className='p-5' type="info" description="Al descargar el informe se exportara un archivo excel en otra pestaña." />
					<Form onSubmit={handleSubmit(onSubmit)} className='mt-10'>
						{ data.datesRangeFilter && (
							<Form.Group>
								<Form.Label>Rango de Fechas <span className='text-danger'>*</span></Form.Label>
								<Row>
									<Col>
										<Form.Control type="date" {...register('from', { required: true })} />
									</Col>
									<Col>
										<Form.Control type="date" {...register('to', { required: true })} />
									</Col>
								</Row>
								{ (errors.from || errors.to) && <Form.Text className='text-warning'>Este campo es requerido</Form.Text> }
							</Form.Group>
						)}
						<Row>
							{ data.yearFilter && (
								<Form.Group as={Col}>
									<Form.Label>Año <span className='text-danger'>*</span></Form.Label>
									<Form.Control
										as="select"
										{...register('year', { required: true })}
									>
										<option value="">:: Seleccione un año ::</option>
										{ [2025, 2024, 2023, 2022, 2021].map(year => (
											<option key={year} value={year}>{year}</option>
										))}
									</Form.Control>
									{ errors.year && <Form.Text className='text-warning'>Este campo es requerido</Form.Text> }
								</Form.Group>
							)}
							{ data.monthFilter && (
								<Form.Group as={Col}>
									<Form.Label>Mes <span className='small'>(opcional)</span></Form.Label>
									<Form.Control
										as="select"
										{...register('month', {})}
									>
										<option value="">:: Seleccione un mes ::</option>
										{ [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => (
											<option key={month} value={month}>{moment().month(month - 1).format('MMMM')}</option>
										))}
									</Form.Control>
								</Form.Group>
							)}
						</Row>
						<Button className='mt-10' color="primary" type="submit" disabled={loading}>
							Descargar{" "}
							{ loading && <Spinner size="sm" className='ml-5' /> }
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</>
	)
}